// Context.js
import React, { createContext } from 'react';

const SeasonContext = createContext();

export default SeasonContext;
